var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResistor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 62,
    viewBox: "0 0 26 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5009_42403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3513 48.7973H24.295V2.56146C21.9717 0.803682 14.2168 0.726634 11.3596 1.26595C9.73188 1.57128 8.88336 3.39754 8.96994 4.90992C11.0191 5.30941 16.6729 5.62616 17.3425 7.89757C17.8042 9.45846 14.9268 16.9205 13.6021 17.591C11.6886 18.5584 4.88615 18.9607 3.16316 17.708C2.80817 17.4484 0.242455 11.0935 0.103923 10.2717C-0.880229 4.36775 5.39409 6.51361 7.59617 4.9727C8.18204 4.56464 7.91364 0.769439 10.8315 0.224413C12.592 -0.103743 20.5547 -0.049527 22.4133 0.241534C23.1896 0.364236 25.3513 1.46284 25.3513 2.03926V48.7973Z",
    fill: "#4D2117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80854 52.0764L6.92141 51.3875C-4.28862 50.9558 1.15221 45.5218 2.55491 38.75C6.5124 39.6076 10.4037 38.5185 14.197 39.0387C14.5513 41.7457 17.9183 46.1221 17.0888 48.6919C16.1498 51.6019 10.709 50.5957 8.8656 52.0764V61.235H7.81141V52.0764H7.80854Z",
    fill: "#4D2117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3453 23.9199V31.9367C10.6972 32.2637 6.94035 33.0928 3.34375 31.9367V24.4542C7.07196 24.641 10.6886 25.003 14.3453 23.9199Z",
    fill: "#E6BC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3396 33.9668L14.3453 36.9354C10.5075 37.1362 7.19013 37.68 3.34375 36.9354L3.35234 33.97C6.81265 35.265 10.7791 34.4524 14.3396 33.97V33.9668Z",
    fill: "#F1805E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34375 22.9641V20.1729C7.08822 20.8737 10.7325 21.1388 14.3453 19.6152L14.268 22.3089C13.8901 22.3912 13.2317 22.961 13.0399 22.961H3.34375V22.9641Z",
    fill: "#F1805E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5009_42403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResistor);
export default __webpack_public_path__ + "static/media/resistor.9272e7b1a50af8c0358e03564f3e4ce8.svg";
export { ForwardRef as ReactComponent };